import Nullstack from 'nullstack';
export default function IconEaseInOutControlPoints({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ease-in-out-control-points",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M17 20h-2"
  }), "   ", Nullstack.element("path", {
    d: "M7 4a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M7 4h2"
  }), "   ", Nullstack.element("path", {
    d: "M14 4h-2"
  }), "   ", Nullstack.element("path", {
    d: "M12 20h-2"
  }), "   ", Nullstack.element("path", {
    d: "M3 20c8 0 10 -16 18 -16"
  }), " ");
}